import React, {memo, useContext, useRef,} from "react"
import ResultsContext, {Results} from "@/contexts/ResultsContext";
import Lessons from "@/Enums/lessons";

type lessonType = Lessons.POLISH | Lessons.MATH | "itemOne" | "itemTwo"

const Cert: React.FC<{ name: string; lesson: lessonType; index: number }> = ({ name, lesson, index }) => {
  const { results, setResults }: any = useContext(ResultsContext)

  const activeMark = useRef(-1)
  const buttonsContainer = useRef<HTMLDivElement | null>(null)

  const HandleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (activeMark.current === Number(e.currentTarget.id)) {
      e.currentTarget.classList.remove("mark-active")
      activeMark.current = -1

      setResults((prev: Results) => ({
        ...prev,
        certs: {
          ...prev.certs,
          [lesson]: 0
        }
      }))
    } else {
      activeMark.current = Number(e.currentTarget.id)

      let points = 0

      switch (e.currentTarget.id) {
        case "2":
          points = 2
          break
        case "3":
          points = 8
          break
        case "4":
          points = 14
          break
        case "5":
          points = 17
          break
        case "6":
          points = 18
          break
      }

      setResults((prev: Results) => ({
        ...prev,
        certs: {
          ...prev.certs,
          [lesson]: points
        }
      }))

      if (buttonsContainer.current)
        buttonsContainer.current.childNodes.forEach(button => {
          if (button instanceof HTMLElement) {
            if (Number(button.id) === activeMark.current) {
              button.classList.add(
                  "border-[rgba(76,161,255,0.719)]",
                  "border",
                  "shadow-lg",
                  "shadow-[rgba(76,161,255,0.2)]"
              )
            } else {
              button.classList.remove(
                  "border-[rgba(76,161,255,0.719)]",
                  "border",
                  "shadow-lg",
                  "shadow-[rgba(76,161,255,0.2)]"
              )
            }
          }
        })
    }
  }

  return (
    <div className='w-full flex justify-between gap-4'>
      <label htmlFor={"cert" + index} className='md:text-4xl text-3xl w-64 font-medium'>
        {name}
      </label>
      <div className='flex gap-16 md:text-5xl text-4xl' ref={buttonsContainer}>
        <button
          onClick={HandleClick}
          className='w-12 rounded-xl transition-all duration-300 outline-none hover:text-[#aaa]'
          id='2'>
          2
        </button>
        <button
          onClick={HandleClick}
          className='w-12 rounded-xl transition-all duration-300 outline-none hover:text-[#aaa]'
          id='3'>
          3
        </button>
        <button
          onClick={HandleClick}
          className='w-12 rounded-xl transition-all duration-300 outline-none hover:text-[#aaa]'
          id='4'>
          4
        </button>
        <button
          onClick={HandleClick}
          className='w-12 rounded-xl transition-all duration-300 outline-none hover:text-[#aaa]'
          id='5'>
          5
        </button>
        <button
          onClick={HandleClick}
          className='w-12 rounded-xl transition-all duration-300 outline-none hover:text-[#aaa]'
          id='6'>
          6
        </button>
      </div>

      <input
        id={"cert" + index}
        type='text'
        disabled
        className='bg-white48 w-40 p-1 rounded-xl text-heading text-center outline-none text-3xl points'
        value={results.certs[lesson]}
      />
    </div>
  )
}

export default memo(Cert)
